export default __webpack_public_path__ + "static/media/C230253.bcbc1e8e.jpg";